import React, { useEffect, useRef, useState } from 'react';
import { GlyphState } from 'konect-model';
import "./InterpolationSlider.css";
import { InterpolationPoint, InterpolationPoints } from '../../services/mxgraph-service';

export interface InterpolationSliderProps {
    state: GlyphState;
    onChange: (points: InterpolationPoints) => void;
    sliderPosition: number;
    index: number;
}

export default function SingleInterpolationSlider(props: InterpolationSliderProps) {
    const containerRef : any = useRef(null);
    const dragging = useRef<any>(null);
    const [pathData, setPathData] = useState('');
    const [points, setPoints] = useState<InterpolationPoint[]>([{ position: 0, on: props.index === 0 }, { position: 1, on: props.index !== 0 }]);
    const isClick = useRef(false);

    useEffect(() => {
        calculatePath();
        props.onChange(new InterpolationPoints(points));
    }, [points]);

    useEffect(() => {
        calculatePath()
    }
    )

    function startDrag(e: any, pointIndex: number) {
        if(e.stopPropagation) e.stopPropagation();
        if(e.preventDefault) e.preventDefault();
        e.cancelBubble=true;
        e.returnValue=false;
        dragging.current = pointIndex;
        document.addEventListener('mousemove', applyCoordinates);
        document.addEventListener('mouseup', endDrag);
        isClick.current = true;
        setTimeout(() => {
            isClick.current = false;
        }, 135)
    }

    function endDrag() {
        if (isClick.current) {
            const p = points[dragging.current];
            p.on = !p.on;
            setPoints([...points]);
        }
        document.removeEventListener('mouseup', endDrag);
        document.removeEventListener('mousemove', applyCoordinates);
        dragging.current = undefined;
    }

    function addPoint() {
        if (points[points.length - 1].position === 1) {
            for (const point of points) {
                point.position /= 2;
            }
        }
        points.push(
            {position: 1, on: true}
        )
        setPoints([...points]);
    }

    function applyCoordinates(event: MouseEvent) {
        if (dragging.current === undefined) return;
        const i = dragging.current;
        const bounds = containerRef.current.getBoundingClientRect();
        const point = points[i]
        const pos = event.clientX - bounds.x;
        const relativePosition = pos / bounds.width;

        point.position = relativePosition;
        if (i === 0 && pos < 0) {
            point.position = 0;
        }
        if (i === points.length - 1 && relativePosition > 1) {
            point.position = 1;
        }
        if (i < points.length - 1) {
            const next = points[i + 1];
            if (next.position < relativePosition) {
                point.position = next.position;
            }
        }
        if (i > 0) {
            const previous = points[i - 1];
            if (previous.position > relativePosition) {
                point.position = previous.position;
            }
        }
        document.body.style.cursor = "";
        setPoints([...points]);
    }

        // calculates the paths between the parent-nodes and their children
        const calculatePath = () => {
            if (points.length <= 0) {
                setPathData("");
                return;
            }
            const svg = document.getElementById("ips-lines");
            if (!svg) return;
            const height = svg?.getBoundingClientRect().height;
            let newPathData = `M ${points[0].position * width} ${height}`;
            for (const point of points) {
                newPathData += ` L ${point.position * width} ${point.on ? 0 : height}`
            }
            newPathData += ` L ${points[points.length - 1].position * width} ${height}`

            setPathData(newPathData)
        }

    const width = containerRef.current ? containerRef.current.getBoundingClientRect().width : 0;
    const height = document.getElementById("ips-lines")?.getBoundingClientRect().height;

    return <>
    <div className='ips-title'>{props.state.name}<span onClick={addPoint}>+</span></div>
    <div className="interpolation-slider" ref={containerRef}>
        <svg id='ips-lines'><path d={pathData} stroke="orange" fill="#ffa50085" /></svg>
        <div id="ips-center" className='ips-slider' style={{ transform: `translateX(${props.sliderPosition * width}px)` }}>
            <div></div>
        </div>
        {points.map((p, i) => 
            <div key={i} id="ips-start" className='point' style={{ transform: `translate(${p.position * width}px, ${p.on ? 0 : height}px)`}} onMouseDown={(e) => {startDrag(e, i); }}>
                <div></div>
            </div>
        )}
    </div>
    </>
}